// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kl-custom-heading .primary-heading {
  color: #000000;
  font-size: 14px;
  font-style: normal;
  font-weight: 600 !important;
  line-height: 1.5;
  padding: 0;
}
.kl-custom-heading .medium {
  font-size: 16px;
  line-height: 1;
}
.kl-custom-heading .aside {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-start;
  margin-bottom: 10px;
}
.kl-custom-heading .aside button {
  background-color: transparent !important;
  color: #000 !important;
  padding: 0 !important;
  width: -moz-fit-content !important;
  width: fit-content !important;
  height: -moz-fit-content !important;
  height: fit-content !important;
  border: 0 !important;
}
.kl-custom-heading .title {
  color: #040f0f;
  font-family: "Poppins", sans-serif;
  font-size: 28px;
  font-weight: 600 !important;
  line-height: 1;
  letter-spacing: 0em;
  text-align: left;
  margin: 0;
  text-transform: capitalize;
}
@media (max-width: 1024px) {
  .kl-custom-heading .auth-heading {
    font-size: 25px;
    text-align: center;
  }
  .kl-custom-heading .big-heading {
    font-size: 35px;
    line-height: 45px;
    text-align: center;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  .kl-custom-heading .title {
    font-size: 22px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .kl-custom-heading .title {
    font-size: 20px;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  .kl-custom-heading .title {
    font-size: 20px;
  }
}
@media (min-width: 280px) and (max-width: 480px) {
  .kl-custom-heading .title {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UiComponents/CustomHeading/CustomHeading.less"],"names":[],"mappings":"AAEA;EAEI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,UAAA;AAFJ;AALA;EAUI,eAAA;EACA,cAAA;AAFJ;AATA;EAcI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;AAFJ;AAhBA;EAoBM,wCAAA;EACA,sBAAA;EACA,qBAAA;EACA,kCAAA;EAAA,6BAAA;EACA,mCAAA;EAAA,8BAAA;EACA,oBAAA;AADN;AAxBA;EA6BI,cAAA;EACA,kCAAA;EACA,eAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,0BAAA;AAFJ;AAMA;EACE;IAEI,eAAA;IACA,kBAAA;EALJ;EAEA;IAMI,eAAA;IACA,iBAAA;IACA,kBAAA;EALJ;AACF;AAwBA;EACE;IACE,eAAA;EAtBF;AACF;AAgCA;EACE;IACE,eAAA;EA9BF;AACF;AAmCA;EACE;IACE,eAAA;EAjCF;AACF;AAsCA;EACE;IACE,eAAA;EApCF;AACF","sourcesContent":["@import url(\"../../../assets/Styles/variables.less\");\n\n.kl-custom-heading {\n  .primary-heading {\n    color: @black-color;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600 !important;\n    line-height: 1.5;\n    padding: 0;\n  }\n  .medium {\n    font-size: 16px;\n    line-height: 1;\n  }\n  .aside {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    justify-content: flex-start;\n    margin-bottom: 10px;\n    button {\n      background-color: transparent !important;\n      color: @nav-dark-text-color !important;\n      padding: 0 !important;\n      width: fit-content !important;\n      height: fit-content !important;\n      border: 0 !important;\n    }\n  }\n  .title {\n    color: @black-link;\n    font-family: @primary-font-family;\n    font-size: 28px;\n    font-weight: 600 !important;\n    line-height: 1;\n    letter-spacing: 0em;\n    text-align: left;\n    margin: 0;\n    text-transform: capitalize;\n    // padding-bottom: 10px;\n  }\n}\n@media (max-width: 1024px) {\n  .kl-custom-heading {\n    .auth-heading {\n      font-size: 25px;\n      text-align: center;\n    }\n    .big-heading {\n      font-size: 35px;\n      line-height: 45px;\n      text-align: center;\n    }\n  }\n}\n\n// MEDIA QUERY START\n\n// ##Device = HD Desktops\n// ##Screen = 1600px to higher resolution desktops\n\n@media screen and (min-width: 1600px) {\n} //  Dont delete this bracket!\n\n// ##Device = Desktops\n// ##Screen = 1281px to higher resolution desktops\n@media (min-width: 1281px) and (max-width: 1599px) {\n} //  Dont delete this bracket!\n\n// ##Device = Laptops, Desktops\n// ##Screen = B/w 1025px to 1280px\n@media (min-width: 1025px) and (max-width: 1280px) {\n  .kl-custom-heading .title {\n    font-size: 22px;\n  }\n} //  1025px to 1280px (Laptops, Desktops) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (landscape)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n} //  768px to 1024px (landscape) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (portrait)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) {\n  .kl-custom-heading .title {\n    font-size: 20px;\n  }\n} //  768px to 1024px (portrait) Dont delete this bracket!\n\n// ##Device = Low Resolution Tablets, Mobiles (Landscape)\n// ##Screen = B/w 481px to 767px\n@media (min-width: 481px) and (max-width: 767px) {\n  .kl-custom-heading .title {\n    font-size: 20px;\n  }\n} //  481px to 767px (Landscape) Dont delete this bracket!\n\n// ##Device = Most of the Smartphones Mobiles (Portrait)\n// ##Screen = B/w 280px to 480px\n@media (min-width: 280px) and (max-width: 480px) {\n  .kl-custom-heading .title {\n    font-size: 18px;\n  }\n} //  280px to 480px (Portrait) Dont delete this bracket!\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
